import React from 'react';
import { Box } from '@mui/material';
import PoolItem from './PoolItem';

export default function PoolList({
  candidateGroup,
  onViewPool,
  showAllPools,
  onTogglePoolsExpansion,
  showItemsThreshold
}: {
  candidateGroup: { id: number; candidate_pools: { id: number; title: string }[] };
  onViewPool?: (poolId: number) => void;
  showAllPools?: boolean;
  onTogglePoolsExpansion?: (candidateGroupId: number) => void;
  showItemsThreshold: number;
}) {
  const pools = candidateGroup.candidate_pools;
  if (pools.length < showItemsThreshold || showAllPools) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 0 }}>
        {pools.map((pool) => (
          <PoolItem key={pool.id} pool={pool} onViewPool={onViewPool} />
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 0 }}>
      <PoolItem pool={pools[0]} onViewPool={onViewPool} />
      <Box
        sx={{
          padding: '5px 10px 5px 20px',
          cursor: 'pointer',
          borderRadius: '26px',
          marginLeft: '-20px',
          border: '10px solid #FFFFFF',
          backgroundColor: '#F5F5F5'
        }}
        onClick={() => onTogglePoolsExpansion && onTogglePoolsExpansion(candidateGroup.id)}
      >
        +{pools.length - 1}
      </Box>
    </Box>
  );
}
